import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth/msal-config';
import { useCallback } from 'react';

/**
 * Hook that returns a function to acquire a bearer token for API calls.
 * Silently acquires from cache, falls back to popup if needed.
 */
export function useApiToken() {
  const { instance, accounts } = useMsal();

  const getToken = useCallback(async (): Promise<string> => {
    if (accounts.length === 0) throw new Error('Not authenticated');

    try {
      const result = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      });
      return result.accessToken;
    } catch {
      const result = await instance.acquireTokenPopup(loginRequest);
      return result.accessToken;
    }
  }, [instance, accounts]);

  return getToken;
}
